import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import upload from '../services/upload';
import auth from '../services/auth';
import './PostEditor.css';

const NewPostPage = () => {
    const [post, setPost] = useState({
        title: '',
        content: '',
        is_published: true
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const navigate = useNavigate();

    React.useEffect(() => {
        if (!auth.isAuthenticated()) {
            navigate('/admin/login');
        }
    }, [navigate]);

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setUploading(true);
        try {
            const result = await upload.uploadImage(file);
            // Insert image markdown at cursor or end of content
            const imageMarkdown = `\n![Image](${result.url})\n`;
            setPost({...post, content: post.content + imageMarkdown});
        } catch (err) {
            alert('Failed to upload image');
            console.error('Error:', err);
        } finally {
            setUploading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        
        try {
            await api.createPost(post);
            navigate('/admin/dashboard');
        } catch (err) {
            setError('Failed to create post');
            console.error('Error:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="editor-container">
            <header className="editor-header">
                <h1><Link to="/">Sercihan's</Link></h1>
            </header>
            
            <div className="editor-content">
                <h2>Create New Post</h2>
                
                {error && (
                    <div className="error-message">
                        {error}
                    </div>
                )}
                
                <form onSubmit={handleSubmit} className="editor-form">
                    <div className="form-group">
                        <label>Title</label>
                        <input
                            type="text"
                            value={post.title}
                            onChange={(e) => setPost({...post, title: e.target.value})}
                            required
                        />
                    </div>
                    
                    <div className="form-group">
                        <div className="label-with-button">
                            <label>Content</label>
                            <label className="upload-button" disabled={uploading}>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageUpload}
                                    style={{ display: 'none' }}
                                    disabled={uploading}
                                />
                                {uploading ? 'Uploading...' : '+ Add Image'}
                            </label>
                        </div>
                        <textarea
                            rows="20"
                            value={post.content}
                            onChange={(e) => setPost({...post, content: e.target.value})}
                            required
                            placeholder="Write your content here. Use Markdown for formatting.\n\nImages will be inserted as: ![Image](/uploads/filename.jpg)"
                        />
                    </div>
                    
                    <div className="form-checkbox">
                        <input
                            type="checkbox"
                            id="publishCheck"
                            checked={post.is_published}
                            onChange={(e) => setPost({...post, is_published: e.target.checked})}
                        />
                        <label htmlFor="publishCheck">
                            Publish immediately
                        </label>
                    </div>
                    
                    <div className="form-actions">
                        <button type="submit" disabled={loading || uploading} className="submit-button">
                            {loading ? 'Creating...' : 'Create Post'}
                        </button>
                        <button
                            type="button"
                            className="cancel-button"
                            onClick={() => navigate('/admin/dashboard')}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default NewPostPage;
